export default __webpack_public_path__ + "static/media/10.abb41d9a.png";